module.exports = {
	"nm": "Main Scene",
	"ddd": 0,
	"h": 500,
	"w": 500,
	"meta": {
		"g": "@lottiefiles/creator 1.46.2"
	},
	"layers": [
		{
			"ty": 0,
			"nm": "Nested Scene 1",
			"sr": 1,
			"st": 0,
			"op": 120,
			"ip": 0,
			"hd": false,
			"ddd": 0,
			"bm": 0,
			"hasMask": false,
			"ao": 0,
			"ks": {
				"a": {
					"a": 0,
					"k": [
						11.820571184158332,
						11.429060041904457
					]
				},
				"s": {
					"a": 0,
					"k": [
						574.5165,
						574.5165
					]
				},
				"sk": {
					"a": 0,
					"k": 0
				},
				"p": {
					"a": 0,
					"k": [
						248,
						248
					]
				},
				"r": {
					"a": 0,
					"k": 0
				},
				"sa": {
					"a": 0,
					"k": 0
				},
				"o": {
					"a": 0,
					"k": 100
				}
			},
			"w": 500,
			"h": 500,
			"refId": "precomp_Shape Layer - SVG_1ed0d1da-9c9f-4fe0-a05d-eb083511d2c0_40257d22-1dfb-4abd-b6ae-4a767322eaa9",
			"ind": 1
		},
		{
			"ty": 4,
			"nm": "Ellipse 1",
			"sr": 1,
			"st": 0,
			"op": 120,
			"ip": 0,
			"hd": false,
			"ddd": 0,
			"bm": 0,
			"hasMask": false,
			"ao": 0,
			"ks": {
				"a": {
					"a": 0,
					"k": [
						0,
						0
					]
				},
				"s": {
					"a": 0,
					"k": [
						80,
						80
					]
				},
				"sk": {
					"a": 0,
					"k": 0
				},
				"p": {
					"a": 0,
					"k": [
						246,
						247
					]
				},
				"r": {
					"a": 1,
					"k": [
						{
							"o": {
								"x": 0.167,
								"y": 0.167
							},
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"s": [
								160
							],
							"t": 0
						},
						{
							"s": [
								-200
							],
							"t": 119
						}
					]
				},
				"sa": {
					"a": 0,
					"k": 0
				},
				"o": {
					"a": 0,
					"k": 100
				}
			},
			"shapes": [
				{
					"ty": "sh",
					"bm": 0,
					"hd": false,
					"nm": "Ellipse Path 1",
					"d": 1,
					"ks": {
						"a": 0,
						"k": {
							"c": true,
							"i": [
								[
									-73.9546,
									0
								],
								[
									0,
									-73.9546
								],
								[
									73.9546,
									0
								],
								[
									0,
									73.9546
								]
							],
							"o": [
								[
									73.9546,
									0
								],
								[
									0,
									73.9546
								],
								[
									-73.9546,
									0
								],
								[
									0,
									-73.9546
								]
							],
							"v": [
								[
									0,
									-134
								],
								[
									134,
									0
								],
								[
									0,
									134
								],
								[
									-134,
									0
								]
							]
						}
					}
				},
				{
					"ty": "tm",
					"bm": 0,
					"hd": false,
					"nm": "Trim Path",
					"e": {
						"a": 1,
						"k": [
							{
								"o": {
									"x": 0.65,
									"y": 0
								},
								"i": {
									"x": 0.36,
									"y": 1
								},
								"s": [
									100
								],
								"t": 4
							},
							{
								"s": [
									0
								],
								"t": 120
							}
						]
					},
					"o": {
						"a": 0,
						"k": 0
					},
					"s": {
						"a": 1,
						"k": [
							{
								"o": {
									"x": 0.55,
									"y": 0.06
								},
								"i": {
									"x": 0.36,
									"y": 1
								},
								"s": [
									100
								],
								"t": 0
							},
							{
								"s": [
									0
								],
								"t": 116
							}
						]
					},
					"m": 1
				},
				{
					"ty": "st",
					"bm": 0,
					"hd": false,
					"nm": "Stroke",
					"lc": 2,
					"lj": 2,
					"ml": 1,
					"o": {
						"a": 0,
						"k": 100
					},
					"w": {
						"a": 0,
						"k": 28
					},
					"c": {
						"a": 0,
						"k": [
							0.3569,
							0.5373,
							0.7843
						]
					}
				}
			],
			"ind": 2
		},
		{
			"ty": 4,
			"nm": "Ellipse 1",
			"sr": 1,
			"st": 0,
			"op": 120,
			"ip": 0,
			"hd": false,
			"ddd": 0,
			"bm": 0,
			"hasMask": false,
			"ao": 0,
			"ks": {
				"a": {
					"a": 0,
					"k": [
						0,
						0
					]
				},
				"s": {
					"a": 0,
					"k": [
						80,
						80
					]
				},
				"sk": {
					"a": 0,
					"k": 0
				},
				"p": {
					"a": 0,
					"k": [
						246,
						247
					]
				},
				"r": {
					"a": 1,
					"k": [
						{
							"o": {
								"x": 0.167,
								"y": 0.167
							},
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"s": [
								60
							],
							"t": 0
						},
						{
							"s": [
								-300
							],
							"t": 119
						}
					]
				},
				"sa": {
					"a": 0,
					"k": 0
				},
				"o": {
					"a": 0,
					"k": 100
				}
			},
			"shapes": [
				{
					"ty": "sh",
					"bm": 0,
					"hd": false,
					"nm": "Ellipse Path 1",
					"d": 1,
					"ks": {
						"a": 0,
						"k": {
							"c": true,
							"i": [
								[
									-73.9546,
									0
								],
								[
									0,
									-73.9546
								],
								[
									73.9546,
									0
								],
								[
									0,
									73.9546
								]
							],
							"o": [
								[
									73.9546,
									0
								],
								[
									0,
									73.9546
								],
								[
									-73.9546,
									0
								],
								[
									0,
									-73.9546
								]
							],
							"v": [
								[
									0,
									-134
								],
								[
									134,
									0
								],
								[
									0,
									134
								],
								[
									-134,
									0
								]
							]
						}
					}
				},
				{
					"ty": "tm",
					"bm": 0,
					"hd": false,
					"nm": "Trim Path",
					"e": {
						"a": 1,
						"k": [
							{
								"o": {
									"x": 0.65,
									"y": 0
								},
								"i": {
									"x": 0.36,
									"y": 1
								},
								"s": [
									100
								],
								"t": 26
							},
							{
								"s": [
									0
								],
								"t": 120
							}
						]
					},
					"o": {
						"a": 0,
						"k": 0
					},
					"s": {
						"a": 1,
						"k": [
							{
								"o": {
									"x": 0.55,
									"y": 0.06
								},
								"i": {
									"x": 0.36,
									"y": 1
								},
								"s": [
									100
								],
								"t": 0
							},
							{
								"s": [
									0
								],
								"t": 96
							}
						]
					},
					"m": 1
				},
				{
					"ty": "st",
					"bm": 0,
					"hd": false,
					"nm": "Stroke",
					"lc": 2,
					"lj": 2,
					"ml": 1,
					"o": {
						"a": 0,
						"k": 100
					},
					"w": {
						"a": 0,
						"k": 28
					},
					"c": {
						"a": 0,
						"k": [
							0.3569,
							0.5373,
							0.7843
						]
					}
				}
			],
			"ind": 3
		},
		{
			"ty": 4,
			"nm": "Ellipse 1",
			"sr": 1,
			"st": 0,
			"op": 122,
			"ip": 0,
			"hd": false,
			"ddd": 0,
			"bm": 0,
			"hasMask": false,
			"ao": 0,
			"ks": {
				"a": {
					"a": 0,
					"k": [
						0,
						0
					]
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100
					]
				},
				"sk": {
					"a": 0,
					"k": 0
				},
				"p": {
					"a": 0,
					"k": [
						246,
						247
					]
				},
				"r": {
					"a": 1,
					"k": [
						{
							"o": {
								"x": 0.167,
								"y": 0.167
							},
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"s": [
								0
							],
							"t": 0
						},
						{
							"s": [
								-359
							],
							"t": 120
						}
					]
				},
				"sa": {
					"a": 0,
					"k": 0
				},
				"o": {
					"a": 0,
					"k": 100
				}
			},
			"shapes": [
				{
					"ty": "sh",
					"bm": 0,
					"hd": false,
					"nm": "Ellipse Path 1",
					"d": 1,
					"ks": {
						"a": 0,
						"k": {
							"c": true,
							"i": [
								[
									-73.9546,
									0
								],
								[
									0,
									-73.9546
								],
								[
									73.9546,
									0
								],
								[
									0,
									73.9546
								]
							],
							"o": [
								[
									73.9546,
									0
								],
								[
									0,
									73.9546
								],
								[
									-73.9546,
									0
								],
								[
									0,
									-73.9546
								]
							],
							"v": [
								[
									0,
									-134
								],
								[
									134,
									0
								],
								[
									0,
									134
								],
								[
									-134,
									0
								]
							]
						}
					}
				},
				{
					"ty": "tm",
					"bm": 0,
					"hd": false,
					"nm": "Trim Path",
					"e": {
						"a": 1,
						"k": [
							{
								"o": {
									"x": 0.65,
									"y": 0
								},
								"i": {
									"x": 0.36,
									"y": 1
								},
								"s": [
									100
								],
								"t": 26
							},
							{
								"s": [
									0
								],
								"t": 120
							}
						]
					},
					"o": {
						"a": 0,
						"k": 0
					},
					"s": {
						"a": 1,
						"k": [
							{
								"o": {
									"x": 0.55,
									"y": 0.06
								},
								"i": {
									"x": 0.36,
									"y": 1
								},
								"s": [
									100
								],
								"t": 0
							},
							{
								"s": [
									0
								],
								"t": 96
							}
						]
					},
					"m": 1
				},
				{
					"ty": "st",
					"bm": 0,
					"hd": false,
					"nm": "Stroke",
					"lc": 2,
					"lj": 2,
					"ml": 1,
					"o": {
						"a": 0,
						"k": 100
					},
					"w": {
						"a": 0,
						"k": 10
					},
					"c": {
						"a": 0,
						"k": [
							0.5176,
							0.6549,
							0.8392
						]
					}
				}
			],
			"ind": 4
		}
	],
	"v": "5.7.0",
	"fr": 60,
	"op": 120,
	"ip": 0,
	"assets": [
		{
			"nm": "Nested Scene 1",
			"id": "precomp_Shape Layer - SVG_1ed0d1da-9c9f-4fe0-a05d-eb083511d2c0_40257d22-1dfb-4abd-b6ae-4a767322eaa9",
			"fr": 60,
			"layers": [
				{
					"ty": 4,
					"nm": "Shape Layer - SVG",
					"sr": 1,
					"st": 0,
					"op": 120,
					"ip": 0,
					"hd": false,
					"ddd": 0,
					"bm": 0,
					"hasMask": false,
					"ao": 0,
					"ks": {
						"a": {
							"a": 0,
							"k": [
								11.820571184158325,
								11.42906004190445
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100
							]
						},
						"sk": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								11.820571184158325,
								11.42906004190445
							]
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"sa": {
							"a": 0,
							"k": 0
						},
						"o": {
							"a": 0,
							"k": 100
						}
					},
					"shapes": [
						{
							"ty": "gr",
							"bm": 0,
							"hd": false,
							"nm": "Group 1",
							"it": [
								{
									"ty": "sh",
									"bm": 0,
									"hd": false,
									"nm": "Path 1",
									"d": 1,
									"ks": {
										"a": 0,
										"k": {
											"c": true,
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0.5866000000000007,
													0.5658799999999999
												],
												[
													0.8145000000000007,
													-0.029886999999999886
												],
												[
													0,
													0
												],
												[
													0.5866300000000004,
													-0.5658799999999999
												],
												[
													-0.0005500000000004945,
													-0.81508
												],
												[
													0,
													0
												],
												[
													-0.32714000000000043,
													-2.170159999999999
												],
												[
													0,
													0
												],
												[
													-2.3636100000000004,
													0.054299999999997794
												],
												[
													0,
													0
												],
												[
													-0.45660000000000167,
													2.319700000000001
												],
												[
													0,
													0
												],
												[
													2.084699999999998,
													0.7176799999999997
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0.0005999999999986017,
													-0.81508
												],
												[
													-0.5865999999999989,
													-0.5658799999999999
												],
												[
													0,
													0
												],
												[
													-0.8145199999999999,
													-0.029886999999999886
												],
												[
													-0.5866300000000004,
													0.5658799999999999
												],
												[
													0,
													0
												],
												[
													-2.06881,
													0.7325999999999997
												],
												[
													0,
													0
												],
												[
													0.4566600000000003,
													2.319700000000001
												],
												[
													0,
													0
												],
												[
													2.3636,
													0.054299999999997794
												],
												[
													0,
													0
												],
												[
													0.3222999999999985,
													-2.1811100000000003
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													16.5515,
													7.12202
												],
												[
													16.5515,
													4.00202
												],
												[
													15.6343,
													1.84084
												],
												[
													13.4415,
													1.00202
												],
												[
													10.1615,
													1.00202
												],
												[
													7.96872,
													1.84084
												],
												[
													7.05151,
													4.00202
												],
												[
													7.05151,
													7.12202
												],
												[
													4.05151,
													12.122
												],
												[
													5.00151,
													17.892
												],
												[
													9.88151,
													21.812
												],
												[
													13.7615,
													21.812
												],
												[
													18.6415,
													17.892
												],
												[
													19.5915,
													12.122
												],
												[
													16.5515,
													7.12202
												]
											]
										}
									}
								},
								{
									"ty": "sh",
									"bm": 0,
									"hd": false,
									"nm": "Path 2",
									"d": 1,
									"ks": {
										"a": 0,
										"k": {
											"c": true,
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0.17360000000000042,
													-0.24269999999999925
												],
												[
													0.29829999999999934,
													-0.0045000000000001705
												],
												[
													0,
													0
												],
												[
													0.17360000000000042,
													0.24259999999999948
												],
												[
													-0.09210000000000029,
													0.28380000000000116
												],
												[
													0,
													0
												],
												[
													0.25489999999999924,
													0.26559999999999917
												],
												[
													-0.6397100000000009,
													0.6042000000000005
												],
												[
													-0.639800000000001,
													-0.6042000000000005
												],
												[
													0.5667000000000009,
													-0.6731999999999996
												],
												[
													-0.11320000000000086,
													-0.35020000000000095
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0.09210000000000029,
													0.28380000000000116
												],
												[
													-0.17360000000000042,
													0.24259999999999948
												],
												[
													0,
													0
												],
												[
													-0.2983000000000011,
													-0.0045000000000001705
												],
												[
													-0.17360000000000042,
													-0.24269999999999925
												],
												[
													0,
													0
												],
												[
													0.11319999999999908,
													-0.35020000000000095
												],
												[
													-0.5666399999999996,
													-0.6731999999999996
												],
												[
													0.6397999999999993,
													-0.6042000000000005
												],
												[
													0.6396999999999995,
													0.6042000000000005
												],
												[
													-0.25489999999999924,
													0.26559999999999917
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													12.8015,
													14.932
												],
												[
													13.0115,
													15.552
												],
												[
													12.8819,
													16.3891
												],
												[
													12.1315,
													16.782
												],
												[
													11.3915,
													16.782
												],
												[
													10.6411,
													16.3891
												],
												[
													10.5115,
													15.552
												],
												[
													10.7215,
													14.932
												],
												[
													10.4915,
													13.932
												],
												[
													10.6217,
													11.6562
												],
												[
													12.9013,
													11.6562
												],
												[
													13.0315,
													13.932
												],
												[
													12.8015,
													14.932
												]
											]
										}
									}
								},
								{
									"ty": "sh",
									"bm": 0,
									"hd": false,
									"nm": "Path 3",
									"d": 1,
									"ks": {
										"a": 0,
										"k": {
											"c": true,
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0.8526000000000007,
													-0.033869999999999845
												],
												[
													0,
													0
												],
												[
													0.03786000000000023,
													-0.8523700000000001
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													-0.03780000000000072,
													-0.8523700000000001
												],
												[
													0,
													0
												],
												[
													-0.8525200000000002,
													-0.033869999999999845
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													8.55151,
													6.78202
												],
												[
													8.91151,
													6.78202
												],
												[
													8.91151,
													6.79202
												],
												[
													15.0515,
													6.79202
												],
												[
													15.0515,
													4.00202
												],
												[
													13.4415,
													2.52202
												],
												[
													10.1615,
													2.52202
												],
												[
													8.55151,
													4.00202
												],
												[
													8.55151,
													6.78202
												]
											]
										}
									}
								},
								{
									"ty": "fl",
									"bm": 0,
									"hd": false,
									"nm": "Fill",
									"c": {
										"a": 0,
										"k": [
											0.1961,
											0.4235,
											0.7294
										]
									},
									"r": 2,
									"o": {
										"a": 0,
										"k": 100
									}
								},
								{
									"ty": "tr",
									"a": {
										"a": 0,
										"k": [
											0,
											0
										]
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										]
									},
									"sk": {
										"a": 0,
										"k": 0
									},
									"p": {
										"a": 0,
										"k": [
											0,
											0
										]
									},
									"r": {
										"a": 0,
										"k": 0
									},
									"sa": {
										"a": 0,
										"k": 0
									},
									"o": {
										"a": 0,
										"k": 100
									}
								}
							]
						}
					],
					"ind": 1
				}
			]
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lotties/PaperworkAuthLoader.json
// module id = 5354
// module chunks = 39